// extracted by mini-css-extract-plugin
export default {"venueRating":"VenueRating--venueRating--31be0b"};